// Reusable Viewport Detection System - Singleton Pattern
class ViewportDetector {
  static instance = null;
  
  static getInstance() {
    if (!ViewportDetector.instance) {
      ViewportDetector.instance = new ViewportDetector();
    }
    return ViewportDetector.instance;
  }
  
  constructor() {
    // Prevent multiple instances
    if (ViewportDetector.instance) {
      return ViewportDetector.instance;
    }
    
    this.lastScrollY = window.scrollY;
    this.scrollDirection = 'down';
    this.observers = new Map();
    this.observedElements = new Set(); // Track individual elements
    
    // Track scroll direction globally
    this.initScrollTracking();
    
    ViewportDetector.instance = this;
  }
  
  initScrollTracking() {
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      this.scrollDirection = currentScrollY > this.lastScrollY ? 'down' : 'up';
      this.lastScrollY = currentScrollY;
    });
  }
  
  // Add elements to watch
  observe(selector, callback, options = {}) {
    const defaultOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
      fireOnce: false // Set to true if you want to fire only once per element
    };
    
    const config = { ...defaultOptions, ...options };
    
    // Create observer for this selector
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.scrollDirection === 'down') {
          console.log(`Element ${selector} entered viewport from top!`);
          
          // Execute the callback
          callback(entry.target, entry);
          
          // Stop observing if fireOnce is true
          if (config.fireOnce) {
            observer.unobserve(entry.target);
          }
        }
      });
    }, {
      threshold: config.threshold,
      rootMargin: config.rootMargin
    });
    
    // Find and observe all matching elements
    const elements = document.querySelectorAll(selector);
    const elementsToObserve = [];
    
    elements.forEach(element => {
      // Create unique identifier for element
      const elementId = element.dataset.viewportId || `${selector}-${Date.now()}-${Math.random()}`;
      element.dataset.viewportId = elementId;
      
      // Only observe if not already being observed
      if (!this.observedElements.has(elementId)) {
        observer.observe(element);
        this.observedElements.add(elementId);
        elementsToObserve.push(element);
      }
    });
    
    // Store observer for cleanup if needed
    this.observers.set(selector, { observer, elements: elementsToObserve });
    
    return this; // Allow chaining
  }
  
  // Remove observer for a selector
  unobserve(selector) {
    if (this.observers.has(selector)) {
      const { observer, elements } = this.observers.get(selector);
      elements.forEach(element => observer.unobserve(element));
      this.observers.delete(selector);
    }
  }
  
  // Cleanup all observers
  destroy() {
    this.observers.forEach(({ observer }) => observer.disconnect());
    this.observers.clear();
  }
}

// Create global instance
window.viewportDetector = new ViewportDetector();

document.addEventListener("DOMContentLoaded", (event) => {
  window.viewportDetector.observe('.dev-feature-section-visible-event', (element) => {
  gaEvent('feauture_viewd', ['', '', '', '', '', ''], false);
});
});